import { React } from "react";
import { useNavigate } from 'react-router-dom';
import DropdownMenu from "../Layout/DropdownMenu";
import "./IndexMapLegend.css";
import "../Layout/DropdownMenu.css";
import TemperatureScenarioSelector from "../Layout/TemperatureScenarioSelector";
import YearRangeSelector from "../Layout/YearRangeSelector";
import GradientLegend from "../Layout/GradientLegend";
import { wildfireStyle, heatwaveStyle, waterStressStyle, cycloneStyle, floodStyle, slrStyle, purpleStyle } from "../Layout/LayerStyle";
import ResilienceSelector from "../Layout/ResilienceSelector";

const IndexMapLegend = (props) => {
  const {
    hazards,
    hazardScoreMetadata,
    selectedHazard,
    setSelectedHazard,
    selectedAdditional,
    setSelectedAdditional,
    temperatureScenarios,
    selectedTemperatureScenario,
    setSelectedTemperatureScenario,
    resilienceValues,
    selectedResilienceValue,
    setSelectedResilienceValue,

    cycloneResilienceValues,
    selectedCycloneResilienceValue,
    setSelectedCycloneResilienceValue,
    wildfireResilienceValues,
    selectedWildfireResilienceValue,
    setSelectedWildfireResilienceValue,

    yearRanges,
    selectedYearRange,
    setSelectedYearRange,
    assetPointsVisible,
    setAssetPointsVisible,
    assetPointsWeightVisible,
    setAssetPointsWeightVisible,
    useTes,
    setUseTes,
    types,
  } = props;

  const navigate = useNavigate();

  const display_hazards = {
    "WILDFIRE": "wildfire",
    "FLOOD": "flood",
    "HEATWAVE": "heatwave",
    "CYCLONE": "cyclone",
    "SEA LEVEL RISE": "SLR",
    "WATER STRESS": "water_stress"
  };

  let additionalLayers = [];
  if (JSON.parse(localStorage.getItem("layers"))) {
    additionalLayers = JSON.parse(localStorage.getItem("layers"));
  }
  const legendOptions = ["ASSET TYPE", "WILDFIRE", "FLOOD", "HEATWAVE", "CYCLONE", "SEA LEVEL RISE", "WATER STRESS", ...additionalLayers.filter(l => typeof l === 'object').map(l => l.name.toUpperCase())];

  const hazardLabelItems = [
    { name: "Low", color: "#89DA59" },
    { name: "Medium", color: "#FBB13C" },
    { name: "High", color: "#ff0000" },
  ];

  const polygonScoreItems = 
    { "wildfire": "Annual likelihood of wildfire occurrence (%)",
      "flood": "Annual likelihood of 50cm+ flood depth (%)",
      "cyclone": "Annual likelihood of Cat.1+ cyclone (%)",
      "heatwave": "Heatwave days per year (%)",
      "SLR": "Sea level rise (m)",
      "water_stress": "Water stress risk (%)",
    };

  let items = hazards.includes(selectedHazard) ? hazardLabelItems : types.slice(0, 15);
  if (items.length === 0) {
    items = [
      {
        "color": "#99E6FF",
        "name": "Default"
      }
    ]
  }

  let scenarioLabel = selectedTemperatureScenario === "4.3°C" ? "ssp585" : "ssp245";
  let selectedHazardPropName = selectedHazard === 'SLR' ? 'sea_level_rise' : selectedHazard; // KEY
  let selectedAdditionalPropName = selectedAdditional ? additionalLayers.filter(l => typeof l === 'object').filter(l => l.name.toUpperCase() === selectedAdditional)[0].key : "";

  let polyColorStyle = purpleStyle;
  if (selectedHazard) {
    if (selectedHazard === "wildfire") {
      polyColorStyle = wildfireStyle;
    } else if (selectedHazard === "heatwave") {
      polyColorStyle = heatwaveStyle;
    }  else if (selectedHazard === "water_stress") {
      polyColorStyle = waterStressStyle;
    }  else if (selectedHazard === "cyclone") {
      polyColorStyle = cycloneStyle;
    }  else if (selectedHazard === "flood") {
      polyColorStyle = floodStyle;
    }  else if (selectedHazard === "SLR") {
      polyColorStyle = slrStyle;
    }
  }
  let gradientStartColor = polyColorStyle.paint["fill-color"][6];
  let gradientEndColor = polyColorStyle.paint["fill-color"][8];
  return (
    <div>

      <div className="map-legend" style={{ overflow: "scroll", msOverflowStyle: 'none', scrollbarWidth: 'none',
                       WebkitScrollbar: { display: 'none' } }}>

      <div style={{display: "flex", flexDirection: "row", gap: "10px", justifyContent: "center"}}>
        <DropdownMenu
          className="legend-dropdown"
          style={{ width: '260px' }}
          options={legendOptions}
          onSelect={(option) => {
            if (option === "ASSET TYPE") {
              setSelectedAdditional(null);
              setSelectedHazard(null);
            } else if (display_hazards.hasOwnProperty(option)) {
              setSelectedAdditional(null);
              setSelectedHazard(display_hazards[option]);
            } else {
              setSelectedAdditional(option);
              setSelectedHazard(null);
            }
          }}
          label={"Layer Selector"}
        />
        <button type="submit" className="import-button"
                onClick={() => navigate('/search')}
                style={{width: "40px", fontWeight: 600}}>
          <span>{"+"}</span>
        </button>
      </div>
        {selectedHazard && (
          <>
          <h3 className="ssp-title">Risk Outlook</h3>
            
          </>
        )}

        {items.map((item) => (
          <div key={item.name} className="legend-item">
            <span
              className="legend-color"
              style={{ backgroundColor: item.color }}
            ></span>
            <span className="legend-text">{item.name}</span>
          </div>
        ))}

          <div className="asset-points-visibility">
            <input
              type="checkbox"
              checked={assetPointsVisible}
              onChange={(e) => setAssetPointsVisible(e.target.checked)}
              className="asset-points-visibility-checkbox"
            />
          <label className="asset-points-visibility-label">Show Asset Points</label>
          </div>
          <div className="asset-points-weighting-visibility">
            <input
              type="checkbox"
              checked={assetPointsWeightVisible}
              onChange={(e) => setAssetPointsWeightVisible(e.target.checked)}
              className="asset-points-weighting-visibility-checkbox"
            />
          <label className="asset-points-visibility-label">Show Portfolio Weight</label>
          </div>          
          <div className="tessellated-boundaries-visibility">
            <input
              type="checkbox"
              checked={useTes}
              onChange={(e) => setUseTes(e.target.checked)}
              className="tessellated-boundaries-visibility-checkbox"
            />
          <label className="asset-points-visibility-label">Show Tessellated</label>
          </div>
          <h4 className="ssp-title">Resilience</h4>
            <ResilienceSelector
               resilienceLabel={"Flood"}
               resilienceValues={resilienceValues}
               selectedResilienceValue={selectedResilienceValue}
               setSelectedResilienceValue={setSelectedResilienceValue}
            />
            <ResilienceSelector
                resilienceLabel={"Wildfire"}
                resilienceValues={wildfireResilienceValues}
                selectedResilienceValue={selectedWildfireResilienceValue}
                setSelectedResilienceValue={setSelectedWildfireResilienceValue}
            />
            <ResilienceSelector
                resilienceLabel={"Cyclone"}
                resilienceValues={cycloneResilienceValues}
                selectedResilienceValue={selectedCycloneResilienceValue}
                setSelectedResilienceValue={setSelectedCycloneResilienceValue}
            />
          <h4 className="ssp-title">Climate Scenario</h4>
            <TemperatureScenarioSelector
              temperatureScenarios={temperatureScenarios}
              selectedTemperatureScenario={selectedTemperatureScenario}
              setSelectedTemperatureScenario={setSelectedTemperatureScenario}
              />
          { selectedHazard && (
          <>
          <h4 className="ssp-title">Forecast Period</h4>
          <YearRangeSelector
            yearRanges={yearRanges}
            selectedYearRange={selectedYearRange}
            setSelectedYearRange={setSelectedYearRange}
            />

          <h4 className="ssp-title">{polygonScoreItems[selectedHazard]}</h4>
          <GradientLegend
            hazard={selectedHazard}
            startColor={gradientStartColor}
            endColor={gradientEndColor}
            startLabel={hazardScoreMetadata[scenarioLabel][selectedHazardPropName][selectedYearRange].min}
            endLabel={hazardScoreMetadata[scenarioLabel][selectedHazardPropName][selectedYearRange].max}
            />
           </>
          )}
          { selectedAdditional && hazardScoreMetadata[scenarioLabel].hasOwnProperty(selectedAdditionalPropName) && (
          <>
          <h4 className="ssp-title">{selectedAdditional.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}</h4>
          <GradientLegend
            hazard={selectedAdditional}
            startColor={gradientStartColor}
            endColor={gradientEndColor}
            startLabel={"0"}
            endLabel={hazardScoreMetadata[scenarioLabel][selectedAdditionalPropName][selectedYearRange].max}
            />
           </>
          )}
      </div>
    </div>
  );
};

export default IndexMapLegend;
